var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"prk-info-box-text",class:(_vm.status + "-color")},[_c('i',{staticClass:"fas fa-circle"}),_vm._v("\n    "+_vm._s(_vm.$t(("general.events.statuses." + _vm.status)))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }